import products from "../products";

let productRouter = [];

for (const [key, val] of Object.entries(products)) {
    val?.ProductDetail && productRouter.push(
        {
            path: `product-${key.toLocaleLowerCase()}`,
            component: val.ProductDetail,
            meta: { name: "产品详情" }
        }
    );
}

export default productRouter